module.exports = __webpack_public_path__ + "img/liucheng4.2f9a0458.png";